import type { ValidationArgs } from "@vuelidate/core";
import { required } from "@vuelidate/validators";

export interface LoginForm {
  username: string;
  password: string;
  authCode: string;
  requestMfaDeviceToken: boolean;
}

export function getLoginFormRules(
  _unusedForm: LoginForm,
): ValidationArgs<LoginForm> {
  return {
    username: { required },
    password: { required },
    authCode: {},
    requestMfaDeviceToken: {},
  };
}

export const validationMessages: Record<keyof LoginForm, object> = {
  username: {
    required: "Please enter your username.",
  },
  password: {
    required: "Please enter your password.",
  },
  authCode: {},
  requestMfaDeviceToken: {},
};

export const fieldLabelsMap: Record<keyof LoginForm, string> = {
  username: "Username",
  password: "Password",
  authCode: "Auth Code",
  requestMfaDeviceToken: "Request MFA Device Token",
};
